import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { NavigateOptions, To, useNavigate } from 'react-router-dom'

const useNavigateToQuadkey = () => {
  const navigate = useNavigate()
  const navigateToQuadkey = (quadkey: Quadkey, event: React.MouseEvent, page?: string, to?: To, toOptions?: NavigateOptions) => {
    const path = to?.toString() ?? `/${page ?? 'quadkey'}/${quadkey.toBase4HashLabel()}`
    if (event.metaKey) {
      window.open(path, '_blank')
    } else {
      navigate(to ?? path, toOptions)
    }
  }
  return { navigateToQuadkey }
}

export { useNavigateToQuadkey }
